import { useNearContext } from '../contexts/NearContext';

const WalletButton = () => {
  const { isSignedIn, signIn, signOut } = useNearContext();

  if (isSignedIn) {
    return (
      <button
        onClick={signOut}
        className="bg-red-100 hover:bg-red-200 text-red-800 px-4 py-2 rounded-lg font-medium transition-colors duration-200"
      >
        Sign Out
      </button>
    );
  }

  return (
    <button
      onClick={signIn}
      className="btn-primary"
    >
      Connect Wallet
    </button>
  );
};

export default WalletButton;
